import { i18n } from '@/plugins/i18n';
import {
  getRecurrenceBreakdown,
  getLabelsAndDatasetsFromRecurrence,
  recurrenceChartOptions,
} from '@/utils/vhub-utils';
import VitalityCriterion from '@/utils/classes/VitalityCategory/VitalityCriterion';


/**
 * Score base on the percentage of NOK items in field tours.
 * Charts also provide information about the recurrence of NOK items.
 */
export default new VitalityCriterion({
  titleTr: 'VH_GW_NOK_RECURRENCE',
  key: 'gwNokRecurrence',
  weight: 2,
  defaultChartIndex: 1,

  score: ({ completedGws }, { start, end }) => {
    // Filter completed GW for the period
    const filtered = completedGws.filter(gw => start.isBefore(gw.date) && end.isAfter(gw.date));
    const nGW = filtered.length;
    let nNok = 0;
    let nTotal = 0;
    // Concat all items into an array
    const allItems = filtered.reduce((stepItems, gw) => {
      const sItems = gw.steps.reduce((clItems, step) => {
        const cItems = step.checklists.reduce((itItems, checklist) => {
          const newItems = checklist.items.filter(item => item.okValue === 0);
          nNok += newItems.length;
          nTotal += checklist.items.length;
          return [...itItems, ...newItems];
        }, []);
        return [...clItems, ...cItems];
      }, []);
      return [...stepItems, ...sItems];
    }, []);

    const breakdown = getRecurrenceBreakdown(allItems, 'template', 'templateText', undefined, 100);
    const score = nTotal === 0 ? 100 : (nTotal - nNok) * 100 / nTotal;

    return {
      score: nGW === 0 ? 0 : score,
      data: {
        score,
        noTopsFlops: allItems.length === 0,
        noCategoryHint: true,
        value: breakdown.maxOccurrences,
        text: breakdown.maxText,
        itemsPerRecurrenceId: breakdown.itemsPerRecurrenceId,
        nGW,
        nTotalItems: nTotal,
      },
    };
  },

  text({ value, text, nGW, score, nTotalItems }) {
    if (nGW === 0) {
      return i18n.t('message.VH_GW_NONE');
    }
    let output = '';
    let recurrenceInfo = '';
    if (value > 1) {
      text = text.length > 28 ? `${text.substring(0, 25)}...` : text;
      recurrenceInfo = i18n.t('message.VH_GW_NOK_RECURRENCE_TEXT', { val: value, text });
    } else {
      recurrenceInfo = i18n.t('message.VH_GW_NOK_RECURRENCE_NONE_TEXT');
    }
    if (nTotalItems > 0) {
      return i18n.t('message.VH_GW_NOK_RECURRENCE_PERCENTAGE', { perc: score.sToFixed(1), recurrenceInfo });
    }
    return recurrenceInfo;
  },

  chartData(teamGroups) {
    // Display a stacked bar chart. The item with the most NOK occurrences first and decreasing
    return getLabelsAndDatasetsFromRecurrence(teamGroups, this.scoresKey);
  },

  chartOptions() {
    return recurrenceChartOptions;
  },

  chartNames() {
    return i18n.t('message.PARETO');
  },
});
